// 공개
export const PUBLIC = "PUBLIC";
export const PUBLIC_LABEL = "공개";

// 비공개
export const PRIVATE = "PRIVATE";
export const PRIVATE_LABEL = "비공개";

// 친구공개
export const FOLLOWED = "CONNECTED";
export const FOLLOWED_LABEL = "친구공개"

// 보호
export const PROTECTED = "PROTECTED";
export const PROTECTED_LABEL = "보호";

export function toLabel(status) {
  switch (status) {
    case PUBLIC :
      return PUBLIC_LABEL;
    case PRIVATE :
      return PRIVATE_LABEL;
    case FOLLOWED :
      return FOLLOWED_LABEL;
    case PROTECTED :
      return PROTECTED_LABEL;
    default:
      return '';
  }
}
